import { Action, createReducer, on } from '@ngrx/store';
import { ILoaderActionPayload, LoadingState } from '../models/loader.model';
import { timelineActions } from './timeline.actions';

export interface TimelineState {
  list: {
    state: ILoaderActionPayload;
    data?: any;
  };
}
const initialState: TimelineState = {
  list: {
    state: {
      value: LoadingState.NONE,
    },
  },
};

const reducer = createReducer(
  initialState,
  // load
  on(timelineActions.load, (state) => ({
    ...state,
    list: { state: { value: LoadingState.LOADING } },
  })),
  on(timelineActions.done, (state, props) => ({
    ...state,
    list: { state: props.state, data: props.data },
  })),
);

export function timelineReducer(state: TimelineState | undefined, action: Action) {
  return reducer(state, action);
}
